import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Widget } from 'reactSite/Modular/components/Widget'

const InnerHtml = styled.div`
  line-height: 1.15;

  ul {
    font-size: 14px;
    list-style-type: disc;
    padding-left: 16px;

    li {
      margin-bottom: 8px;
    }
  }

  ol {
    padding: 0 40px;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  h1 {
    font-size: 40px;
    font-weight: 500;
    margin-top: 26px;
    margin-bottom: 10px
  }

  h2 {
    font-size: 30px;
    font-weight: 500;
    margin-top: 24px;
    margin-bottom: 10px;
  }

  h3 {
    font-size: 24px;
    font-weight: 500;
    margin-top: 24px;
    margin-bottom: 10px;
  }

  p {
    font-size: 14px;
    line-height: 24px;
    margin-top: 14px;
    margin-bottom: 14px;
    display: block;
  }

  u {
    text-decoration: underline;
  }

  strong {
    font-weight: 700;
  }

  em {
    font-style: italic;
  }

  blockquote {
    margin-top: 16px;
    margin-bottom: 16px;
    padding-left: 40px;
  }

  img {
    max-width: 100%;
  }
`

const Markdown = ({ widget }) => {
  if (widget) {
    if (widget.content) {
      return (
        <Widget>
          <InnerHtml dangerouslySetInnerHTML={{ __html: widget.content }} />
        </Widget>
      )
    }

    return (
      <Widget>
        <InnerHtml dangerouslySetInnerHTML={{ __html: JSON.parse(widget) }} />
      </Widget>
    )
  }

  return null
}

Markdown.propTypes = {
  widget: PropTypes.shape({
    content: PropTypes.string,
    title: PropTypes.string
  }).isRequired
}
export default Markdown
